<div class="support-rich-text" (focusout)="onFocusOut($event)">
  <!-- mousedown-preventDefault: de editor houdt focus én selectie terwijl je een toolbar-knop klikt. -->
  <div
    class="support-rich-text-toolbar"
    role="toolbar"
    [attr.aria-label]="'support.composer.toolbar' | transloco"
    (mousedown)="$event.preventDefault()"
  >
    <button
      type="button"
      class="support-rich-text-tool"
      [class.is-active]="activeTools().has('bold')"
      [disabled]="disabled()"
      [attr.aria-pressed]="activeTools().has('bold')"
      [attr.aria-label]="'support.composer.bold' | transloco"
      [title]="'support.composer.bold' | transloco"
      (click)="bold()"
      data-test-id="support-composer-bold"
    >
      <i eIcon icon="bold"></i>
    </button>
    <button
      type="button"
      class="support-rich-text-tool"
      [class.is-active]="activeTools().has('italic')"
      [disabled]="disabled()"
      [attr.aria-pressed]="activeTools().has('italic')"
      [attr.aria-label]="'support.composer.italic' | transloco"
      [title]="'support.composer.italic' | transloco"
      (click)="italic()"
      data-test-id="support-composer-italic"
    >
      <i eIcon icon="italic"></i>
    </button>
    <button
      type="button"
      class="support-rich-text-tool"
      [class.is-active]="activeTools().has('underline')"
      [disabled]="disabled()"
      [attr.aria-pressed]="activeTools().has('underline')"
      [attr.aria-label]="'support.composer.underline' | transloco"
      [title]="'support.composer.underline' | transloco"
      (click)="underline()"
      data-test-id="support-composer-underline"
    >
      <i eIcon icon="underline"></i>
    </button>
    <button
      type="button"
      class="support-rich-text-tool"
      [class.is-active]="activeTools().has('strikeThrough')"
      [disabled]="disabled()"
      [attr.aria-pressed]="activeTools().has('strikeThrough')"
      [attr.aria-label]="'support.composer.strikethrough' | transloco"
      [title]="'support.composer.strikethrough' | transloco"
      (click)="strikethrough()"
      data-test-id="support-composer-strikethrough"
    >
      <i eIcon icon="strikethrough"></i>
    </button>
    <button
      type="button"
      class="support-rich-text-tool"
      [class.is-active]="activeTools().has('superscript')"
      [disabled]="disabled()"
      [attr.aria-pressed]="activeTools().has('superscript')"
      [attr.aria-label]="'support.composer.superscript' | transloco"
      [title]="'support.composer.superscript' | transloco"
      (click)="superscript()"
      data-test-id="support-composer-superscript"
    >
      <i eIcon icon="superscript"></i>
    </button>
    <div class="support-rich-text-popup-holder">
      <button
        type="button"
        class="support-rich-text-tool"
        [disabled]="disabled()"
        [attr.aria-expanded]="colorOpen()"
        [attr.aria-label]="'support.composer.color' | transloco"
        [title]="'support.composer.color' | transloco"
        (click)="toggleColor()"
        data-test-id="support-composer-color"
      >
        <i eIcon icon="palette"></i>
      </button>
      @if (colorOpen()) {
        <div class="support-rich-text-color-panel" data-test-id="support-composer-color-panel">
          @for (swatch of swatches; track swatch.key) {
            <button
              type="button"
              class="support-rich-text-swatch"
              [style.background]="swatch.hex"
              [attr.aria-label]="swatch.key"
              [title]="swatch.key"
              (click)="applyColor(swatch.hex)"
              data-test-id="support-composer-color-swatch"
            ></button>
          }
        </div>
      }
    </div>
    <button
      type="button"
      class="support-rich-text-tool"
      [class.is-active]="activeTools().has('insertUnorderedList')"
      [disabled]="disabled()"
      [attr.aria-pressed]="activeTools().has('insertUnorderedList')"
      [attr.aria-label]="'support.composer.list' | transloco"
      [title]="'support.composer.list' | transloco"
      (click)="bulletList()"
      data-test-id="support-composer-list"
    >
      <i eIcon icon="list-ul"></i>
    </button>
    <button
      type="button"
      class="support-rich-text-tool"
      [disabled]="disabled()"
      [attr.aria-label]="'support.composer.reset' | transloco"
      [title]="'support.composer.reset' | transloco"
      (click)="resetFormatting()"
      data-test-id="support-composer-reset"
    >
      <i eIcon icon="eraser"></i>
    </button>
    <div class="support-rich-text-popup-holder">
      <button
        type="button"
        class="support-rich-text-tool"
        [disabled]="disabled()"
        [attr.aria-expanded]="emojiOpen()"
        [attr.aria-label]="'support.composer.emoji' | transloco"
        [title]="'support.composer.emoji' | transloco"
        (click)="toggleEmoji()"
        data-test-id="support-composer-emoji"
      >
        <i eIcon icon="face-smile"></i>
      </button>
      @if (emojiOpen()) {
        <div class="support-rich-text-emoji-panel" data-test-id="support-composer-emoji-panel">
          @for (item of emoji; track item) {
            <button type="button" class="support-rich-text-emoji-option" (click)="insertEmoji(item)" data-test-id="support-composer-emoji-option">
              {{ item }}
            </button>
          }
        </div>
      }
    </div>

    <ng-content select="[richTextToolbarExtra]"></ng-content>
  </div>

  <!-- WYSIWYG: de opmaak wordt direct toegepast; `value` blijft de markup-opslagvorm. -->
  <div
    #editor
    class="support-rich-text-input"
    [attr.contenteditable]="disabled() ? 'false' : 'true'"
    [attr.data-placeholder]="placeholder()"
    [attr.aria-label]="ariaLabel() || placeholder()"
    (input)="onInput()"
    (paste)="onPaste($event)"
    data-test-id="support-rich-text-input"
  ></div>
</div>
